// extracted by mini-css-extract-plugin
module.exports = {"ecDataInfos":"Data_ecDataInfos__CCcg7","showScale":"Data_showScale__IPfGX"};